import { ParagraphSnapshot } from '../../../core/types/Typesetter';

/**
 * Phase2CacheClearer - Utility for clearing Phase 2 pagination caches
 *
 * Manages the clearing of all Phase 2-related caches and state when document
 * reinitialization or major changes require a clean slate for incremental pagination.
 */
export class Phase2CacheClearer {
  /**
   * Clear all Phase 2 caches and reset related state
   *
   * This method clears all caches related to incremental pagination:
   * - Cached paragraph snapshots
   * - Paragraph-to-page mappings
   * - Page hashes for early termination
   *
   * Called during document reinitialization to ensure clean state for
   * subsequent pagination operations.
   *
   * @param cachedParagraphSnapshots - Array of cached paragraph snapshots (will be cleared)
   * @param paragraphToPageMap - Map of paragraph IDs to page indices (will be cleared)
   * @param pageHashes - Map of page indices to page hashes (will be cleared)
   * @returns New total page count (always 0 after clearing)
   */
  static clearPhase2Caches(
    cachedParagraphSnapshots: ParagraphSnapshot[],
    paragraphToPageMap: Map<string, number[]>,
    pageHashes: Map<number, string>
  ): number {
    cachedParagraphSnapshots.length = 0; // Clear the array
    paragraphToPageMap.clear();
    pageHashes.clear();
    console.log(`📊 [Phase2CacheClearer] Cleared all Phase 2 caches`);
    return 0; // Return the reset total page count
  }
}
